import { CART_MODULE } from "@/api_framework/api_config";
import { ICartItemDeletePayload, ICartListResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const useCartItemDeleteAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (deletePayload: ICartItemDeletePayload, cartType: "normal" | "hd") => {
      try {
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${CART_MODULE?.CART_ITEM_DELETE?.baseURL}`, deletePayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartListResponse>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "Delete Success" };
            } else {
              dispatch(
                setLoading({
                  key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "Delete Unsuccessfull" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
                status: false,
              }),
            );
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e) {
        captureError(e);
        dispatch(
          setLoading({
            key: cartType === "normal" ? "isCustomerCartTableInProgress" : "isCustomerHDCartTableInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
